import { REQUEST_INSTA_POSTS_SUCCESS, REQUEST_INSTA_POSTS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instaDashboardPosts(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_INSTA_POSTS_SUCCESS:
     
      return { ...state, data: action.payload.data, errors: null };
      
    case REQUEST_INSTA_POSTS_FAILURE:
      return { ...state, data: [], errors: null };
    
      default:
      return state;
  }
}
